export const hasBreadcrumbs = (state) => {
  const arrBreadcrumbs = state && state.app && state.app.breadcrumbs;
  return arrBreadcrumbs && arrBreadcrumbs.length !== 0;
};
